export const mashupRewardItems = [
    {
      name: 'KFC Voucher',
      id: 'kfc',
      amount: 50,
      image: '/assets/images/kfcmw.jpg'
    },
    {
      name: 'Potbelly Voucher',
      id: 'potbelly',
      amount: 50,
      image: '/assets/images/potbellymw.jpg'
    },
    {
      name: 'Shoprite Voucher',
      id: 'shoprite',
      amount: 50,
      image: '/assets/images/shopritemw.jpg'
    },
    {
      name: 'Melcom Voucher',
      id: 'melcom-voucher',
      amount: 50,
      image: '/assets/images/melcome_cns.jpg'
    },
  ];


